import classnames from 'classnames'

import { Alert, AlertProps, Button, IconAlertTriangle } from '@/components'

type InvalidCredentialsAlertProps = AlertProps

export const InvalidCredentialsAlert = ({
    className,
    ...props
}: InvalidCredentialsAlertProps) =>
    <Alert
        type="custom"
        icon={<div className="w-10 h-10 rounded-full bg-error-50 flex justify-center items-center">
            <div className="w-8 h-8 rounded-full bg-error-100 flex justify-center items-center stroke-error-700">
                <IconAlertTriangle/>
            </div>
        </div>}
        className={classnames(className, 'bg-white border-error-300 font-body')}
        {...props}
    >
        <div className="flex gap-2 flex-col lg:flex-row items-start lg:items-center justify-between grow">
            <p className="leading-6">
                <span className="font-semibold">You have invalid or missing monitoring credentials!</span><br/>
                Update now to enable Solar Insure Monitoring.
            </p>
            <Button design="btn-secondary" href="/profile/integrations" className="whitespace-nowrap font-normal">
                Update Credentials
            </Button>
        </div>
    </Alert>
